/**
 * @packageDocumentation
 * @module Auth
 * @category Core
 */

import { inject, Injectable } from '@angular/core';
import { AuthProfileState } from '@app/core/auth/states/auth-profile.state';
import { ReloadControlProvider } from '@app/core/reload-control/reload-control.provider';
import { Store } from '@ngxs/store';
import { distinctUntilChanged, map, Observable, skip } from 'rxjs';

/**
 * Имплементация {@link ReloadControlProvider} для перезагрузки данных без перезагрузки страницы при смене пользователя.
 *
 * @see {@link ReloadControlProvider}
 *
 * @group Services
 */
@Injectable({
  providedIn: 'root',
})
export class AuthReloadControlService implements ReloadControlProvider {
  private readonly store = inject(Store);

  public shouldReloadData(): Observable<boolean> {
    return this.store.select(AuthProfileState.userEmail).pipe(
      skip(1),
      distinctUntilChanged(),
      map(() => true),
    );
  }
}
